function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 14c7.738 14 20.262 14 28 0C20.262 0 7.738 0 0 14zm14 4.3a4.3 4.3 0 110-8.6 4.3 4.3 0 010 8.6z"
});

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAyOCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTAgMTRjNy43MzggMTQgMjAuMjYyIDE0IDI4IDBDMjAuMjYyIDAgNy43MzggMCAwIDE0em0xNCA0LjNjLTIuMzc1IDAtNC4zLTEuOTI1LTQuMy00LjNzMS45MjUtNC4zIDQuMy00LjMgNC4zIDEuOTI1IDQuMyA0LjNjLS4wMDEgMi4zNzQtMS45MjYgNC4yOTktNC4zIDQuM3oiLz4KPC9zdmc+Cg==";
export { SvgEye as ReactComponent };